import styled from "styled-components";
import { usePermissions } from "@/hooks/usePermissions";
import { Helmet } from "react-helmet-async";
import AccessDeniedMessage from "@/components/AccessDeniedMessage.js";
import { Typography } from "@monolith-forensics/monolith-ui";
import EquipmentTable from "@/Features/Equipment/Tables/EquipmentTable";

const EquipmentSectionContent = styled(
  ({ className, stateStoreKey = "equipment:view:v2" }) => {
    return (
      <div className={className}>
        <Helmet title="Forensic Equipment" />
        <Typography
          variant="h3"
          gutterBottom
          display="inline"
          style={{ margin: 0 }}
        >
          Forensic Equipment
        </Typography>
        <EquipmentTable stateStoreKey={stateStoreKey} />
      </div>
    );
  }
)`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const EquipmentSection = () => {
  const { hasPermission, MONOLITH_PERMISSIONS } = usePermissions();

  if (!hasPermission(MONOLITH_PERMISSIONS.EQUIPMENT_READ_ALL)) {
    return <AccessDeniedMessage />;
  }

  return <EquipmentSectionContent />;
};

export default EquipmentSection;
